// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { productAttributesStyles } from "@insite/content-library/Components/ProductAttributes";
import { partNumberAndAttributeStyles } from "@rpsc/App/WidgetExtensions/ProductList/ProductListProductCardExtensions";
import { fontConfig } from "@rpsc/XDL/PreStyle/typography";
import { css } from "styled-components";

productAttributesStyles.attributeTypeGridItem = {
    ...partNumberAndAttributeStyles,
};
productAttributesStyles.attributeValueGridItem = {
    ...partNumberAndAttributeStyles,
};

productAttributesStyles.attributeTypeText = {
    size: 12,
    lineHeight: "17px",
    weight: fontConfig.weight.bold,
    color: "common.black",
    css: css`
        &::after {
            content: ":";
        }
    `,
};

productAttributesStyles.attributeValueText = {
    size: 12,
    lineHeight: "17px",
    color: "common.ui5",
};
